export default __webpack_public_path__ + "static/media/projectShareHeader.3563ca9f.jpg";